import { MallAxiosInterceptor } from "api/core/consts";

export const cart = {
  getMallCart: (mallCartId) => MallAxiosInterceptor.get('/mallCart/' + mallCartId),
  searchMallCart: (paging, body) => MallAxiosInterceptor.post('/mallCart/search' + paging, body),
  createMallCart: (body) => MallAxiosInterceptor.post('/mallCart', body),
  updateMallCart: (mallCartId, body) => MallAxiosInterceptor.put('/mallCart/' + mallCartId, body),
  deleteMallCart: (mallCartId) => MallAxiosInterceptor.delete('/mallCart/' + mallCartId),
};
